"use client"

import * as React from "react"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell } from 'recharts';
import {
    Card, CardContent, CardHeader, CardTitle, CardDescription,
} from "src/@/components/ui/card"
import { ChartContainer } from "src/@/components/ui/chart"
import { Tooltip as ShadTooltip, TooltipContent as ShadTooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip"
import { Info } from "lucide-react"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const chartConfig = {
    provavel: { label: "Provável", color: "#8b5cf6" },
    conservador: { label: "Conservador", color: "#d1d5db" },
};

export function GraficoForecast({ provavel = 0, conservador = 0 }) {
    const data = [
        { tipo: 'Conservador', valor: conservador },
        { tipo: 'Provável', valor: provavel },
    ];

    const formatCurrency = (value) => {
        if (value >= 1000000) return `R$${(value / 1000000).toFixed(1)}M`;
        if (value >= 1000) return `R$${(value / 1000).toFixed(1)}k`;
        return `R$${value}`;
    };

    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <div className="flex items-center gap-1">
                        <CardTitle>Forecast de Vendas</CardTitle>
                        <TooltipProvider>
                            <ShadTooltip>
                                <TooltipTrigger asChild>
                                    <Info className="w-3.5 h-3.5 text-gray-400 cursor-help" />
                                </TooltipTrigger>
                                <ShadTooltipContent side="top" className="max-w-xs text-xs">
                                    <p>Projecao de receita: Conservador considera apenas negocios nos 2 ultimos estagios do funil. Provavel pondera o valor de cada negocio pela taxa de conversao historica do estagio</p>
                                </ShadTooltipContent>
                            </ShadTooltip>
                        </TooltipProvider>
                    </div>
                    <CardDescription>Projeção de receita baseada no pipeline atual</CardDescription>
                </div>
            </CardHeader>
            <CardContent>
                {(provavel === 0 && conservador === 0) ? (
                    <EmptyContentGhost />
                ) : (
                    <ChartContainer className="w-full h-[300px]" config={chartConfig}>
                        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="tipo" />
                            <YAxis tickFormatter={formatCurrency} />
                            <Tooltip formatter={(value) => formatCurrency(value)} />
                            <Bar dataKey="valor" radius={[4, 4, 0, 0]}>
                                <LabelList dataKey="valor" position="top" fontSize={14} formatter={formatCurrency} />
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={index === 0 ? '#d1d5db' : '#8b5cf6'} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ChartContainer>
                )}
            </CardContent>
        </Card>
    )
}
